import { DOCUMENT } from '@angular/common';
import { Inject, RendererFactory2 } from '@angular/core';
import { Injectable } from '@angular/core';
import { Renderer2 } from '@angular/core';

import { LoggerService } from '@wdpr/ra-angular-logger';

import { AppLocaleService } from '../app-locale/app-locale.service';
import { OneIdConfig } from '../../interfaces/one-id-config.interface';
import { WindowRef } from '../../window-ref/window-ref.service';

/**
 * Do not use NativeBridgeService as a dependency because it produces
 * a circular dependency error in some SPA's
 */

@Injectable({
    providedIn: 'root',
})
export class OneIdScriptLoaderService {
    script: {
        loaded: boolean;
    } ;
    private renderer: Renderer2;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        rendererFactory: RendererFactory2,
        private appLocaleService: AppLocaleService,
        private loggerService: LoggerService,
        private windowRef: WindowRef
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.script = { loaded: false };
    }

    /**
     * Loads the passed script and resolves the promise when the script has been loaded.
     * @param src script url
     * @returns Promise<boolean> indicating script has loaded
     */
    loadJsScript( oneIdConfig: OneIdConfig ):  Promise<boolean> {
        return new Promise((resolve, reject) => {
                if (this.script.loaded || this.windowRef?.nativeWindow['disney']?.device?.embedded) {
                    return resolve(true);
                }
    
                const script = this.renderer.createElement('script');
                script.type = 'text/javascript';
                script.src = oneIdConfig.authenthicatorBundleScript;
    
                script.onload = () => {
                    this.script.loaded = true;
                    if (!this.windowRef?.PEP?.PROFILE_AUTH?.isInitialized) {
                        this.windowRef?.PEP.PROFILE_AUTH.init({
                            oneIdScriptSrc: oneIdConfig.oneIdScriptSrc,
                            loadScript: true,
                            clientId: oneIdConfig.webClientId,
                            langPref: this.appLocaleService.content()
                        }).then(() => {
                            resolve(true);    
                        });
                    } else {
                        resolve(true);
                    }
                };
    
                script.onerror = (error: any) => {
                    this.loggerService.error("An error ocurred while loading authenticator script", error);
                    reject(false);
                };
    
                this.renderer.appendChild(this.document.body, script);
        });
    }
}
